import React, { useEffect, useState } from "react";
import CustomSelect from "../common/CustomSelect";
import { getAllCrewEmployeesWithoutPaginationApi } from "../apis/crewEmployee";
import { useDispatch } from "react-redux";
import { showNotification } from "../redux/actions/notification";

const SelectCrewMember = ({ value, onChange }) => {
  const [crewMembers, setCrewMembers] = useState([]);
  const dispatch = useDispatch();
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const tenantId = currentUser?.tenant?.id || null;
  const zoneId = currentUser?.zone?.id || null;
  const zoneName = currentUser?.zone?.name || null;

  useEffect(() => {
    async function fetchCrewMembers() {
      try {
        const query = {};
        if (tenantId) {
          query.tenantId = tenantId;
        } else {
          if (zoneId) query.zoneId = zoneId;
          if (zoneName) query.zoneName = zoneName;
        }
        const response = await getAllCrewEmployeesWithoutPaginationApi(query);
        if (response) {
          setCrewMembers(response);
        }
      } catch (error) {
        console.error("Failed to fetch crew members:", error);
        dispatch(
          showNotification({
            type: "error",
            message: "Unable to fetch crew members",
          })
        );
      }
    }

    fetchCrewMembers();
  }, []);

  const crewOptions = crewMembers.map((member) => ({
    value: member.employeeId,
    label: `ID: ${member.employeeId}: Name: ${member.employeeName}`,
  }));

  return (
    <CustomSelect
      label="Select Employee"
      placeholder="Select Employee"
      value={value}
      onChange={onChange}
      options={crewOptions}
      mode="single"
      style={{ width: 220 }}
    />
  );
};

export default SelectCrewMember;
